export const PazaakConfig = {
  name: "Pazaak",
  textures: [
    {
      name: "Card Back",
      file: "lbl_cardback"
    },
    {
      name: "Card Hilight",
      file: "lbl_cardhilite"
    },
    {
      name: "Card Drawn",
      file: "lbl_cardstand"
    },
    {
      name: "Card Positive",
      file: "lbl_cardmpos"
    },
    {
      name: "Card Negative",
      file: "lbl_cardmneg"
    },
    {
      name: "Card Reversible Positive",
      file: "lbl_cardrarem"
    },
    {
      name: "Card Reversible Negative",
      file: "lbl_cardraref"
    }
  ],
  data: {
    rounds: 3,
    mainDeckCards: [
      {
        name: "Base 1",
        type: 0,
        modifier: [1, 0],
        modifierLabel: '1',
        reversible: false,
        negateModifier: false,
        textures: [
          'lbl_cardstand',
          'lbl_cardback'
        ]
      },
      {
        name: "Base 2",
        type: 0,
        modifier: [2, 0],
        modifierLabel: '2',
        reversible: false,
        negateModifier: false,
        textures: [
          'lbl_cardstand',
          'lbl_cardback'
        ]
      },
      {
        name: "Base 3",
        type: 0,
        modifier: [3, 0],
        modifierLabel: '3',
        reversible: false,
        negateModifier: false,
        textures: [
          'lbl_cardstand',
          'lbl_cardback'
        ]
      },
      {
        name: "Base 4",
        type: 0,
        modifier: [4, 0],
        modifierLabel: '4',
        reversible: false,
        negateModifier: false,
        textures: [
          'lbl_cardstand',
          'lbl_cardback'
        ]
      },  
      {
        name: "Base 5",
        type: 0,
        modifier: [5, 0],
        modifierLabel: '5',
        reversible: false,
        negateModifier: false,
        textures: [
          'lbl_cardstand',
          'lbl_cardback'
        ]
      },
      {
        name: "Base 6",
        type: 0,
        modifier: [6, 0],
        modifierLabel: '6',
        reversible: false,
        negateModifier: false,
        textures: [
          'lbl_cardstand',
          'lbl_cardback'
        ]
      },
      {
        name: "Base 7",
        type: 0,
        modifier: [7, 0],
        modifierLabel: '7',
        reversible: false,
        negateModifier: false,
        textures: [
          'lbl_cardstand',
          'lbl_cardback'
        ]
      }, 
      {
        name: "Base 8",
        type: 0,
        modifier: [8, 0],
        modifierLabel: '8',
        reversible: false,
        negateModifier: false,
        textures: [
          'lbl_cardstand',
          'lbl_cardback'
        ]
      },
      {
        name: "Base 9",
        type: 0,
        modifier: [9, 0],
        modifierLabel: '9',
        reversible: false,
        negateModifier: false,
        textures: [
          'lbl_cardstand',
          'lbl_cardback'
        ]
      },
      {
        name: "Base 10",
        type: 0,
        modifier: [10, 0],
        modifierLabel: '10',
        reversible: false,
        negateModifier: false,
        textures: [
          'lbl_cardstand',
          'lbl_cardback'
        ]
      }
    ],
    sideDeckCards: [
      {
        name: "Plus 1",
        type: 1,
        modifier: [1, 0],
        modifierLabel: "+1",
        reversible: false,
        negateModifier: false,
        textures: [
          'lbl_cardmpos',
          'lbl_cardback'
        ]
      },
      {
        name: "Plus 2",
        type: 1,
        modifier: [2, 0],
        modifierLabel: "+2",
        reversible: false,
        negateModifier: false,
        textures: [
          'lbl_cardmpos',
          'lbl_cardback'
        ]
      },
      {
        name: "Plus 3",
        type: 1,
        modifier: [3, 0],
        modifierLabel: "+3",
        reversible: false,
        negateModifier: false,
        textures: [
          'lbl_cardmpos',
          'lbl_cardback'
        ]
      },
      {
        name: "Plus 4",
        type: 1,
        modifier: [4, 0],
        modifierLabel: "+4",
        reversible: false,
        negateModifier: false,
        textures: [
          'lbl_cardmpos',
          'lbl_cardback'
        ]
      },
      {
        name: "Plus 5",
        type: 1,
        modifier: [5, 0],
        modifierLabel: "+5",
        reversible: false,
        negateModifier: false,
        textures: [
          'lbl_cardmpos',
          'lbl_cardback'
        ]
      },
      {
        name: "Plus 6",
        type: 1,
        modifier: [6, 0],
        modifierLabel: "+6",
        reversible: false,
        negateModifier: false,
        textures: [
          'lbl_cardmpos',
          'lbl_cardback'
        ]
      },
      {
        name: "Minus 1",
        type: 1,
        modifier: [-1, 0],
        modifierLabel: "-1",
        reversible: false,
        negateModifier: false,
        textures: [
          'lbl_cardmneg',
          'lbl_cardback'
        ]
      },
      {
        name: "Minus 2",
        type: 1,
        modifier: [-2, 0],
        modifierLabel: "-2",
        reversible: false,
        negateModifier: false,
        textures: [
          'lbl_cardmneg',
          'lbl_cardback'
        ]
      },
      {
        name: "Minus 3",
        type: 1,
        modifier: [-3, 0],
        modifierLabel: "-3",
        reversible: false,
        negateModifier: false,
        textures: [
          'lbl_cardmneg',
          'lbl_cardback'
        ]
      },
      {
        name: "Minus 4",
        type: 1,
        modifier: [-4, 0],
        modifierLabel: "-4",
        reversible: false,
        negateModifier: false,
        textures: [
          'lbl_cardmneg',
          'lbl_cardback'
        ]
      },
      {
        name: "Minus 5",
        type: 1,
        modifier: [-5, 0],
        modifierLabel: "-5",
        reversible: false,
        negateModifier: false,
        textures: [
          'lbl_cardmneg',
          'lbl_cardback'
        ]
      },
      {
        name: "Minus 6",
        type: 1,
        modifier: [-6, 0],
        modifierLabel: "-6",
        reversible: false,
        negateModifier: false,
        textures: [
          'lbl_cardmneg',
          'lbl_cardback'
        ]
      },
      {
        name: "Plus/Minus 1",
        type: 1,
        modifier: [1, -1],
        modifierLabel: "±1",
        reversible: true,
        negateModifier: false,
        textures: [
          'lbl_cardrarem', // positive
          'lbl_cardraref' // negative
        ]
      },
      {
        name: "Plus/Minus 2",
        type: 1,
        modifier: [2, -2],
        modifierLabel: "±2",
        reversible: true,
        negateModifier: false,
        textures: [
          'lbl_cardrarem', // positive
          'lbl_cardraref' // negative
        ]
      },
      {
        name: "Plus/Minus 3",
        type: 1,
        modifier: [3, -3],
        modifierLabel: "±3",
        reversible: true,
        negateModifier: false,
        textures: [
          'lbl_cardrarem', // positive
          'lbl_cardraref' // negative
        ]
      },
      {
        name: "Plus/Minus 4",
        type: 1,
        modifier: [4, -4],
        modifierLabel: "±4",
        reversible: true,
        negateModifier: false,
        textures: [
          'lbl_cardrarem', // positive
          'lbl_cardraref' // negative
        ]
      },
      {
        name: "Plus/Minus 5",
        type: 1,
        modifier: [5, -5],
        modifierLabel: "±5",
        reversible: true,
        negateModifier: false,
        textures: [
          'lbl_cardrarem', // positive
          'lbl_cardraref' // negative
        ]
      },
      {
        name: "Plus/Minus 6",
        type: 1,
        modifier: [6, -6],
        modifierLabel: "±6",
        reversible: true,
        negateModifier: false,
        textures: [
          'lbl_cardrarem', // positive
          'lbl_cardraref' // negative
        ]
      }
    ]
  }
}